import React from "react";
import { useParams, useNavigate } from "react-router-dom";
// Kept as a lightweight redirect target — the dashboard opens the editor modal directly.
export default function AdminShopEdit() {
  const { shopId } = useParams();
  const nav = useNavigate();
  React.useEffect(() => { nav("/admin", { replace: true, state: { openEdit: shopId } }); }, [shopId, nav]);
  return null;
}
